import { supabase } from "@/integrations/supabase/client";

export const getUserFacts = async (): Promise<{ facts: string[], summary: string, updateCount: number, maxUpdates: number }> => {
  const { data, error } = await supabase.functions.invoke("preferences", {
    body: { action: "get" },
  });

  if (error) throw error;
  return {
    facts: (data?.userFacts || []) as string[],
    summary: (data?.userFactsSummary || "") as string,
    updateCount: data?.updateCount || 0,
    maxUpdates: data?.maxUpdates || 2
  };
};

export const setUserFacts = async (userFacts: string[], summary?: string): Promise<void> => {
  const body: any = { action: "set", userFacts };
  if (summary !== undefined) {
    body.userFactsSummary = summary;
  }

  const { data, error } = await supabase.functions.invoke("preferences", {
    body,
  });

  if (error) throw error;
  if (data && !data.success) {
    throw new Error(data.error || "Failed to save preferences");
  }
};
